import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

import { NkPicker } from './picker';
import { NkPickerInput } from './picker-input';

const NK_DIRECTIVES: Type<any>[] = [NkPicker, NkPickerInput];
const modules: Type<any>[] = [CommonModule, MatInputModule, FormsModule];

@NgModule({
  imports: [...modules],
  declarations: [...NK_DIRECTIVES],
  exports: [...NK_DIRECTIVES]
})
export class NkPickerModule {}
